import { Vestiging } from "@/entities/vestiging";
import { FaciliteitenDetailsForStation } from "./faciliteiten-details-for-station";

interface LokaleVestigingenSectionProps {
    vestigingenByStation: Record<string, Vestiging[]>;
}

export function LokaleVestigingenSection({ vestigingenByStation }: Readonly<LokaleVestigingenSectionProps>) {
    return (
        <div className="space-y-4">
            <h4 className="text-xl font-medium">Lokale vestigingen</h4>
            {Object.entries(vestigingenByStation).map(([stationCode, vestigingen]) => {
                return <FaciliteitenDetailsForStation key={stationCode} stationCode={stationCode} vestigingen={vestigingen} />;
            })}
        </div>
    );
}
